'use strict';

$ = jQuery;

var body = $('body');
// let offerSlider = $('#card-list-offer-slider');
var offerSlider = $('#jc-offer-slider');
var offerModal = $('#offer-form-modal');
var offerModalLoader = $('#jc-loader-modal-offer');
var offerForm = offerModal.find('.offer-form');
var phoneModal = $('#offer-phones-list');
var Offer_id = '';

// offerSlider.slick({
//   dots: true,
//   arrows: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   autoplay: false,
//   adaptiveHeight: false,
//   lazyLoad: 'ondemand',
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: 'unslick'
//     }
//   ]
// });

offerSlider.on("click", "a[data-target='#offer-form-modal']", function (e) {
  var offerID = $(e.currentTarget).data('offer-id');
  Offer_id = offerID;
  loadOffer(offerID, 'catalogo-0km', offerForm);

  e.preventDefault();
  var observer = new MutationObserver(completion_form_load);
  var targetNode = $('#offer-form-modal')[0];
  observer.observe(targetNode, { childList: true, subtree: true });
});

offerModal.on('click', '.jc-offer-back', function () {
  offerModal.modal('hide');
  offerForm.html('');
  offerModalLoader.show();
});

offerModal.on('click', '#offer-phones', function () {
  $('#offer-phones-list').modal({
    backdrop: 'static'
  });
  $('#offer-phones-list').css({
    padding: '0 0 0 0'
  });
  $('.offer-phones-list-dialog').css({
    height: '-webkit-fill-available',
    display: 'flex'
  });
  $('.offer-phones-list-content').css({
    height: '90vh',
    margin: 'auto'
  });
  $('.offer-phones-list-body').css({
    overflow: 'auto'
  });
});

offerModal.on('click', '#offer-phones-list .jc-offer-dealerships-back', function (e) {
  e.preventDefault();
  $('#offer-phones-list').modal('hide');
});

offerModal.on("shown.bs.modal", function () {
  if ($('.modal.show').length > 1) {
    offerModal.css({
      overflowY: 'hidden'
    });
    $('#offer-phones-list').css({
      backgroundColor: 'rgb(0 0 0 / 0.6)'
    });
    document.getElementsByClassName("offer-phones-list-body")[0].scrollIntoView({ block: 'center' });
  }
  body.css({
    position: 'fixed',
    width: '100%',
    top: '-' + window.scrollY + 'px'
  });
});

offerModal.on("hidden.bs.modal", function () {
  if ($('.modal.show').length > 0) {
    $('body').addClass('modal-open');
    offerModal.css({
      overflowY: 'auto'
    });
  } else {
    var scrollY = document.body.style.top;
    offerForm.html('');
    offerModalLoader.show();
    body.css({
      position: '',
      top: ''
    });
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
});

var loadOffer = function loadOffer(offerID, context, offerForm) {
  $.ajax({
    url: ajaxHandler.url,
    type: 'POST',
    data: {
      action: 'jc_ajax_modal_offer_content',
      offerID: offerID
    },
    success: function success(response) {
      if (response && response.success) {
        offerModalLoader.hide();
        offerForm.trigger('offerLoaded');
        offerForm.html(response.data.template);
        send_offer_form_steps_events(offerID);
        form(offerID, context).then(function (leadID) {
          loadThankYouPage(leadID, offerID, offerForm);
        });
      }
    }
  });
};

var loadThankYouPage = function loadThankYouPage(leadID, offerID, offerForm) {
  $.ajax({
    url: ajaxHandler.url,
    type: 'POST',
    data: {
      action: 'jc_ajax_modal_thank_you_page_content',
      offerID: offerID,
      leadID: leadID
    },
    success: function success(response) {
      if (response && response.success) {
        offerForm.trigger('thankYouPageLoaded');
        offerForm.html(response.data.template);
      }
    }
  });
};